import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { ProductCard } from "./ProductCard";
import { defaultData } from "./ProductCardDefaultData";
import { meta } from "./ProductCardMetaData";

export const ProductCardBlock: BlockExport = {
  type: "component",
  Block: ProductCard,
  defaultData,
  meta,
};
